// src/components/ui/card.jsx
import React from "react";
import { cn } from "../../lib/utils";

export function Card({ className, ...props }) {
    return (
        <div
            className={cn(
                "rounded-2xl border border-zinc-200/80 bg-white text-zinc-950 shadow-card transition-all duration-300 dark:border-zinc-800/80 dark:bg-zinc-900/60 dark:text-zinc-50 dark:backdrop-blur",
                className
            )}
            {...props}
        />
    );
}

export function CardHeader({ className, ...props }) {
    return <div className={cn("p-5 pb-2", className)} {...props} />;
}

export function CardTitle({ className, ...props }) {
    return (
        <h3
            className={cn("text-base font-semibold leading-tight tracking-tight", className)}
            {...props}
        />
    );
}

export function CardDescription({ className, ...props }) {
    return (
        <p className={cn("text-sm leading-relaxed text-zinc-600 dark:text-zinc-400", className)} {...props} />
    );
}

export function CardContent({ className, ...props }) {
    return <div className={cn("p-5 pt-2", className)} {...props} />;
}

export function CardFooter({ className, ...props }) {
    return (
        <div className={cn("flex items-center justify-between gap-2 p-5 pt-2", className)} {...props} />
    );
}
